import { useEffect, useRef } from "react";

type UseOutsideClickProps = {
  onOutsideClick: (event: Event) => void;
  enabled?: boolean;
};

export function useOutsideClick<T extends HTMLElement>({
  onOutsideClick,
  enabled = true,
}: UseOutsideClickProps) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutsideClick(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [onOutsideClick, enabled]);

  return ref;
}
